import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import axios from 'axios';
import { connect } from 'react-redux';
// import {Actions as TEAMACTIONS} from '../../store/actions/teamActions';
import { Actions as WORKLOCATIONACTIONS } from '../../store/actions/workLocationActions';
import WorkLocationRow from "./WorkLocationRow";
import Select from 'react-select';
import _ from 'lodash';
import { DateInputFormat } from "../common/DateComponents";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import cleanDeep from 'clean-deep';
import Spinner from "../common/Spinner";
import { ArrowDownTrayIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";

const TeamWorkLocation = ({
  workLocationLoading,
  workLocationUpdating,
  workLocation,
  departmentOptions,
  getWorkLocation,
  employeeOptions,
  workLocationTypeOptions,
  workLocationStatusOptions,
  workLocationReportUpdating,
  saveWorkLocation,
  showCancelWorkLocation,
  jobTypeOptions,
  downloadDetailedReport
}) => {

  const [employee, setEmployee] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [workLocationType, setWorkLocationType] = useState();
  const [jobType, setJobType] = useState();
  const [workLocationStatus, setWorkLocationStatus] = useState(
    {
      value: "Pending",
      label: "Pending",
    }
  );
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState(new Date());
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    // const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayOfMonth = new Date(today.getFullYear(), 0, 1);
    return new Date(firstDayOfMonth.getTime() - (firstDayOfMonth.getTimezoneOffset() * 60000));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), 12, 0);
    return new Date(lastDayOfMonth.getTime() - (lastDayOfMonth.getTimezoneOffset() * 60000));
  });

  const [loaded, setLoaded] = useState(false);

  const updateWorkLocation = () => {

    const from = startDate && new Date(startDate.getTime() - (startDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    const to = endDate && new Date(endDate.getTime() - (endDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)

    getWorkLocation(cleanDeep({
      from,
      to,
      employee: employee && employee.value,
      type: workLocationType && workLocationType.value,
      status: workLocationStatus && workLocationStatus.value,
      department: selectedDepartment && selectedDepartment.value,
    }))

  }

  const getDetailedWorkLocationReport = () => {

    const from = startDate && new Date(startDate.getTime() - (startDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    const to = endDate && new Date(endDate.getTime() - (endDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)

    downloadDetailedReport(cleanDeep({
      from,
      to,
      employee: employee && employee.value,
      type: workLocationType && workLocationType.value,
      status: workLocationStatus && workLocationStatus.value,
      jobType: jobType && jobType.value,
      department: selectedDepartment && selectedDepartment.value,
    }))

  }

  useEffect(() => {

    const from = startDate && new Date(startDate.getTime() - (startDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
    const to = endDate && new Date(endDate.getTime() - (endDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)

    getWorkLocation(cleanDeep({
      from,
      to,
      employee: employee && employee.value,
      type: workLocationType && workLocationType.value,
      status: workLocationStatus && workLocationStatus.value,
      department: selectedDepartment && selectedDepartment.value,
    }))

  }, []);

  const urlParams = new URLSearchParams(window.location.search)
  const urlStatus = urlParams.get('status');
  const urlTeamID = urlParams.get('teamID');
  const urlWorkLocationID = urlParams.get('WorkLocationID');

  useEffect(() => {
    if (urlTeamID && urlStatus && urlWorkLocationID && workLocation) {
      // time to give it a try
      const workLocationItem = workLocation.find(({ id }) => id == urlWorkLocationID)

      if (workLocationItem) {
        if (urlStatus == "Approved") {
          const workLocationData = {
            agreement: workLocationItem.agreement,
            status: urlStatus,
            id: workLocationItem.entry_id,
            teamID: urlTeamID
          }

          saveWorkLocation(workLocationData);
        } else {
          showCancelWorkLocation(workLocationItem, "Denied")
        }
      }

    }

  }, [urlWorkLocationID, urlStatus, workLocation])

  // this mutates object not ideal
  if (jobType && workLocation && workLocation[0] && !workLocation[0].jobType) {
    workLocation.map(item => {
      const option = employeeOptions.find(employee => employee.value == item.agreement)
      if (option) {
        item.jobType = option.jobType
      } else {
        console.log('noEmployee??', item.agreement)
      }
    })
  }

  // console.log('connected',connected,connectLink)

  return (
    <div>

      {workLocation &&
        <div className="content" >
          <div>
            <div className="row" style={{ paddingTop: 0 }}>
              <h5>View Work Location Requests</h5>
            </div>

            <div>

              <div className="form-group">
                <div >
                  <div className="col-sm-3 col-xs-6">
                    <label>From</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        if(date)
                          setStartDate(date)
                      }}
                      dateFormat="dd/MM/yyyy"
                      customInput={<DateInputFormat />}
                    />
                    {/*<input id="date" type="text" className="form-control remove_error" name="date"/>*/}
                    <div className="clearfix" />
                  </div>
                  <div className="col-sm-3 col-xs-6">
                    <label htmlFor=" ">To</label>
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => {
                        if (date && format(date,'yyyy-MM-dd') <= format(startDate,'yyyy-MM-dd') && format(date,'yyyy') == format(startDate,'yyyy')){
                          setStartDate(date)
                        }
                        console.log('date',date,startDate)
                        setEndDate(date)
                      }}
                      dateFormat="dd/MM/yyyy"
                      customInput={<DateInputFormat />}
                    />
                    <div className="clearfix" />
                  </div>

                  {workLocationTypeOptions &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Location</label>
                      <Select
                        value={workLocationType}
                        options={workLocationTypeOptions}
                        onChange={setWorkLocationType}
                        isClearable={true}
                      />
                      <div className="clearfix" />
                    </div>
                  }
                  {workLocationStatusOptions &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Status</label>
                      <Select
                        value={workLocationStatus}
                        options={workLocationStatusOptions}
                        onChange={setWorkLocationStatus}
                        isClearable={true}
                      />
                      <div className="clearfix" />
                    </div>
                  }
                  <div className="clearfix" />
                </div>
                <div style={{ marginTop: 15 }}>
                  {employeeOptions &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Employee</label>
                      <Select
                        value={employee}
                        options={employeeOptions}
                        onChange={setEmployee}
                        isClearable={true}
                      />
                      <div className="clearfix" />
                    </div>
                  }
                  {departmentOptions &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Department</label>
                      <Select
                        value={selectedDepartment}
                        options={departmentOptions}
                        onChange={setSelectedDepartment}
                        isClearable={true}
                      />
                      <div className="clearfix" />
                    </div>
                  }
                  {jobTypeOptions &&
                    <div className="col-sm-3 col-xs-6">
                      <label htmlFor="material-text">Employment Type</label>
                      <Select
                        value={jobType}
                        options={jobTypeOptions}
                        onChange={setJobType}
                        isClearable={true}
                      />
                      <div className="clearfix" />
                    </div>
                  }

                  <div className="col-sm-3 col-xs-6">

                    {/* <div
                      className="btn btn-success pull-right"
                      style={{
                        marginLeft: "10px",
                        marginTop: "27px"
                      }}
                      onClick={getDetailedWorkLocationReport}
                    >
                      {detailedReportDownloading ?
                        <Spinner
                          style={{ height: "1.5em", float: "left" }}
                          className="animate-spin -ml-1 mr-3 h-5 w-5 "
                        />
                        : <ArrowDownTrayIcon style={{ height: "1.5em", float: "left" }} />
                      }
                    </div> */}
                    {(startDate <= endDate) &&
                      <div
                        className="btn btn-success pull-right"
                        style={{
                          marginTop: "27px"
                        }}
                        onClick={updateWorkLocation}
                      >
                        {workLocationUpdating &&
                          <span>
                            <Spinner
                              style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                              className="animate-spin -ml-1 mr-3 h-5 w-5 "
                            />
                            View Work Location Requests
                          </span>
                          ||
                          <span>
                            <MagnifyingGlassIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            View Work Location Requests
                          </span>
                        }
                      </div>
                    }
                    {!(startDate <= endDate) &&
                      <div 
                        className="btn btn-default pull-right"
                        style={{
                          marginTop: "27px"
                        }}
                      >
                        Invalid Date Range
                      </div>

                    }
                    <div className="clearfix" />
                  </div>
                  <div className="clearfix" />
                </div>
              </div>

            </div>

            {
              workLocation && !workLocationLoading &&
              <div className="table-responsive">
                <table id="table-timesheets" className="js-table-sections table table-hover">
                  <thead>
                    <tr>
                      <th>Team Member</th>
                      <th>Dept.</th>
                      <th>Appl. Date</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Hours</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobType ?
                      workLocation && workLocation
                        .filter(item => item.jobType == jobType.value)
                        .map(entry => (<WorkLocationRow key={entry.id} workLocation={entry} />))
                      :
                      workLocation && workLocation.map(entry => (<WorkLocationRow key={entry.id} workLocation={entry} />))
                    }
                  </tbody>
                </table>
              </div>
            }


            <div className="clearfix" />

          </div>
        </div>
      }

    </div>
  );
}


const mapStateToProps = (state) => {

  const {
    workLocationLoading,
    workLocationUpdating,
    workLocation,
    workLocationBalances,
    workLocationTypes,
    currentDepartment,
    workLocationReportUpdating,
    detailedReportDownloading
  } = state.workLocation

  //All the company's employee
  const employeeListWithSalary = state && state.employees && state.employees.employeeListWithSalary

  const employeeOptions = employeeListWithSalary && employeeListWithSalary.map(employee => ({
    value: employee.id,
    label: `${employee.employeeName} ${employee.employeeSurname}`,
    jobType: employee.employmentTypeName
  }))

  const workLocationTypeOptions = workLocationTypes && workLocationTypes.map(workLocationType => ({
    value: workLocationType.id,
    label: workLocationType.name
  }))

  const workLocationStatusOptions = [
    {
      value: "Approved",
      label: "Approved",
    },
    {
      value: "Pending",
      label: "Pending",
    },
    {
      value: "Cancelled",
      label: "Cancelled",
    },
    {
      value: "Denied",
      label: "Denied",
    },
    {
      value: "Deleted",
      label: "Deleted",
    },
    {
      value: "Pending Cancellation",
      label: "Pending Cancellation",
    }
  ]

  const departmentOptions = state.company?.settings?.departments?.map(department => ({
    value: department.id,
    label: department.name
  }))

  const sortedWorkLocation = _.orderBy(workLocation, ["start", "employeeName", "employeeSurname"], ["desc", "asc", "asc"])

  const jobTypeOptions = [
    {
      value: "Part-time",
      label: "Part-Time",
    },
    {
      value: "Full-time",
      label: "Full-Time",
    }
  ]

  return {
    workLocationLoading,
    workLocationUpdating,
    workLocation: sortedWorkLocation,
    workLocationBalances,
    workLocationTypes,
    currentDepartment,
    employeeOptions,
    employeeListWithSalary,
    departmentOptions,
    workLocationTypeOptions,
    workLocationStatusOptions,
    workLocationReportUpdating,
    jobTypeOptions,
    detailedReportDownloading,
  }
}

const mapDispatchToProps = dispatch => ({
  setOpenModal: (status, WorkLocation) => dispatch(WORKLOCATIONACTIONS.setOpenModal(status, WorkLocation)),
  getWorkLocation: (options) => dispatch(WORKLOCATIONACTIONS.workLocationGet(options, false)),
  downloadDetailedReport: (options) => dispatch(WORKLOCATIONACTIONS.downloadDetailedReport(options)),
  getWorkLocationBalance: () => dispatch(WORKLOCATIONACTIONS.getWorkLocationBalance()),
  getWorkLocationBalanceReport: () => dispatch(WORKLOCATIONACTIONS.getWorkLocationBalanceReport()),
  saveWorkLocation: (WorkLocation) => dispatch(WORKLOCATIONACTIONS.saveWorkLocation(WorkLocation)),
  showCancelWorkLocation: (WorkLocation, status) => dispatch(WORKLOCATIONACTIONS.showCancelWorkLocation(WorkLocation, status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamWorkLocation) 
